import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  Observable,
  of,
  startWith,
  tap,
} from 'rxjs';

import { GET_MARKETING_CONTENT_JSON_URL } from '../../assets/constants';
import { FeatureFlagService } from '../services/feature-flag.service';
import { RuntimeConfigService } from '../services/runtime-config';
import { FeatureFlag } from '../shared/constants/feature-flag.enum';
import { MarketingContent } from './marketing-content.model';

@Injectable({
  providedIn: 'root',
})
export class MarketingContentService {
  private s3BucketUrl: string;
  private marketingContent: MarketingContent | null | undefined;
  private showMarketingContentSubject = new BehaviorSubject<boolean>(false);
  showMarketingContent$: Observable<boolean> =
    this.showMarketingContentSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private runtimeConfigService: RuntimeConfigService,
    private featureFlagService: FeatureFlagService
  ) {
    this.s3BucketUrl =
      this.runtimeConfigService.prequalConfig?.APP_JSON_S3_BUCKET_URL ?? '';

    this.initializeShowMarketingContent();
  }

  getMarketingContent(): Observable<MarketingContent | null> {
    if (this.marketingContent !== undefined) {
      return of(this.marketingContent as MarketingContent);
    } else {
      return this.http
        .get<MarketingContent>(
          `${this.s3BucketUrl}${GET_MARKETING_CONTENT_JSON_URL}`
        )
        .pipe(
          tap((response) => (this.marketingContent = response)),
          catchError((error) => {
            console.error('Error fetching marketing content', error);
            this.marketingContent = null;
            return of(this.marketingContent);
          })
        );
    }
  }

  private initializeShowMarketingContent(): void {
    this.featureFlagService.isEnabled(FeatureFlag.MARKETING_CONTENT).subscribe({
      next: (isEnabled: boolean) => {
        this.showMarketingContentSubject.next(isEnabled);
      },
      error: (error: any) => {
        console.error('Error fetching initial feature flag state:', error);
      },
    });
  }
}
